// SwitcherPopup.jsx

import React from 'react';

// CSS
import './SwitcherPopup.css';

// Components
import SwitcherPopupHeader from 'main/sidebar/switcher/popup/header/SwitcherPopupHeader';
import BaseList from 'main/sidebar/switcher/popup/baselist/BaseList';

/**
 * SwitcherPopup
 * 
 * Renders the popup component for the sidebar switcher.
 * 
 * @param {function} onBaseSelect - Handler for base selection.
 * @param {function} onBaseAdd - Handler for adding a new base.
 *  
 *
 * @returns {ReactNode} - SwitcherPopup.
 */
const SwitcherPopup = React.memo(({
    onBaseSelect,
    onBaseAdd,
    bases = [],
    activeBaseKey = null,
}) => {

    // ----- RENDER ----- //

    return (
        <div
          className="switcher-popup-container"
        >
            <SwitcherPopupHeader />

            {/* MY BASES LABEL */}
            <div className="switcher-popup-spaces-label-wrapper">
                My Workspaces
            </div>

            <BaseList
              bases={bases}
              activeBaseKey={activeBaseKey}
              onAdd={onBaseAdd}
              onSelect={onBaseSelect}
            />
        </div>
    );

});

// Dev Tools
SwitcherPopup.displayName = 'SwitcherPopup';

export default SwitcherPopup;
